<template>
  <tr>
    <td>
      {{ item.name }}
    </td>
    <td>
      <div
        v-if="
          $userCheckAccess({
            abilities: 'edit_scheme_classes',
          })
        "
        class="buttons"
      >
        <WorkDocsSchemeClassModal :create="false" :id="item.id" />
        <DeleteModal
          :item="item"
          :text="
            localStorage.translations.pages['setting-scheme_class']['dialog_delete'][
              'udalit-soderzhanie-chertezha'
            ] +
            ' ' +
            item.name
          "
        />
      </div>
    </td>
  </tr>
</template>

<script>
import WorkDocsSchemeClassModal from 'components/setting/workDocsSchemeClass/WorkDocsSchemeClassModal'
import DeleteModal from 'components/DeleteModal'

export default {
  name: 'WorkDocsSchemeClassTableItem',
  components: { WorkDocsSchemeClassModal, DeleteModal },
  props: ['item'],
}
</script>
